import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const reorderLevelStructures = (resource, id, structureIds) => {
  return axios.put(`/api/${resource}/${id}/setup/level_structures/order`, {
    level_structure_ids: structureIds,
  });
};

export const useReorderLevelStructures = (resource, id, onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (structureIds) => reorderLevelStructures(resource, id, structureIds),
    onSuccess: () => {
      onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(
        error?.response?.data?.description || error?.message || 'Some error occured',
        {
          variant: 'error',
        }
      );
    },
  });
};
